<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/utils/shadcn/lib/utils'

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
    <p
        data-slot="field-description"
        :class="cn(
            'text-neutral-600 text-sm leading-normal font-normal group-has-[[data-layout=horizontal]]/field:text-balance',
            'last:mt-0 nth-last-2:-mt-1 [[data-variant=legend]+&]:-mt-2.5',
            '[&>a:hover]:text-primary [&>a]:underline [&>a]:underline-offset-4',
            props.class,
        )"
    >
        <slot></slot>
    </p>
</template>
